import { render, staticRenderFns } from "./AreaReservada.vue?vue&type=template&id=bb3e5be0&scoped=true"
import script from "./AreaReservada.vue?vue&type=script&lang=js"
export * from "./AreaReservada.vue?vue&type=script&lang=js"
import style0 from "./AreaReservada.vue?vue&type=style&index=0&id=bb3e5be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3e5be0",
  null
  
)

export default component.exports